export default __webpack_public_path__ + "static/media/virtual_services_code_fr.3295c286.png";